<template>
  <div>
    <el-form v-if="blank">
      <el-card class="box-card">
        <div slot="header">
          <h3>
            <el-form-item label="タイトル">
              <el-input v-model="page.title" placeholder="（例）選ばれる４つの理由"></el-input>
            </el-form-item>
          </h3>
          <span style="font-size: 14px; color: #888">
            <el-form-item label="スラッグ">
              <el-input v-model="page.slug" placeholder="（例）four-reasons"></el-input>
            </el-form-item>
          </span>
        </div>
        <el-form-item label="親ページの選択" label-width="120px" v-if="type === 'page'">
          <el-select class="width-50" value-key="link" v-model="page.parent" placeholder="固定ページから選択">
            <el-option class="el-opp"
              :key="0"
              label="なし"
              :value="0">
            </el-option>
            <el-option class="el-opp"
              v-for="page in pages"
              :key="page.id"
              :label="page.title.rendered"
              :value="page.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="メニュー内順序" label-width="120px" v-if="type === 'page'">
          <el-input type="number" v-model="page.menu_order" placeholder="0"></el-input>
        </el-form-item>
        <div class=card-content>
          <el-form-item label="状態" style="margin-bottom: 0">
            <el-radio-group v-model="page.status">
              <el-radio label="draft">下書き</el-radio>
              <el-radio label="publish">公開中</el-radio>
              <el-radio label="private">非公開</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="flex justify-center items-center">
          <el-button type=primary @click=onCreate($event)><i class="fa fa-plus-circle"></i>Create</el-button>
        </div>
      </el-card>
    </el-form>
    <el-form v-if="!blank">
      <el-card class="box-card">
        <div slot="header">
          <span class="card-rightTop flex column justify-center items-center">{{ page.id }}</span>
          <h3 v-model="page.title.rendered"><input class=inherit v-model="page.title.rendered">
          </h3>
          <span style="font-size: 14px; color: #888"><input class=inherit v-model="page.slug">
          </span>
        </div>
        <div class=card-content>
          <el-form-item label="状態">
            <el-radio-group v-model="page.status">
              <el-radio label="draft">下書き</el-radio>
              <el-radio label="publish">公開中</el-radio>
              <el-radio label="private">非公開</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="親ページの選択" label-width="120px" v-if="type === 'page'">
            <el-select class="width-50" value-key="link" v-model="page.parent" placeholder="固定ページから選択">
              <el-option class="el-opp"
                :key="0"
                label="なし"
                :value="0">
              </el-option>
              <el-option class="el-opp"
                v-for="page in pages"
                :key="page.id"
                :label="page.title.rendered"
                :value="page.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="メニュー内順序" label-width="120px" v-if="type === 'page'">
            <el-input type="number" v-model="page.menu_order" placeholder="0"></el-input>
          </el-form-item>
          <el-form-item label="作成日">
            <el-date-picker
              v-model="page.date"
              type="datetime"
              placeholder="Select date and time">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="flex justify-between items-center">
          <el-button type=primary class=icon-button>
            <a :href="page.link" target="_blank">
              <i class="fa fa-external-link"></i>
            </a>
          </el-button>
          <el-button type=primary @click="onUpdate($event)">
            <i class="fa fa-refresh"></i>
          </el-button>
          <el-button type=danger @click="onDelete($event)">
            <i class="fa fa-trash-o"></i>
          </el-button>
          <el-button type=primary class=icon-button>
            <router-link :to="{name: type, params: {id: page.id}}">
              <i class="fa fa-pencil"></i>
            </router-link>
          </el-button>
        </div>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'card-list-item',
  props: ['blank', 'page', 'type', 'pages'],
  methods: {
    onCreate: function ($event) {
      this.$emit('create', this.page)
    },
    onUpdate: function ($event) {
      this.$emit('update', this.page)
    },
    onDelete: function ($event) {
      this.$emit('delete', this.page.id)
    }
  }
}
</script>

<style scoped lang="scss">
h3 {
  margin: 0;
}
.el-button {
  & a {
    color: inherit;
    text-decoration: none;
  }
}
.box-card {
  position: relative;
  min-height: 371px;
}
.card {
  &-rightTop {
    position: absolute;
    padding: .25em .5em 0 0;
    top: 0;
    right: 0;
    z-index: 0;
    font-size: 11px;
    color: #fff;
    &:before {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      top: 0;
      right: 0;
      z-index: -1;
      border-style: solid;
      border-width: 0 3.5em 3.5em 0;
      border-color: transparent #324157 transparent transparent;
    }
  }
  &-content {
    padding-bottom: 1em;
  }
}

.el-button {
  &.icon-button {
    padding: 0;
    a {
      padding: 10px 15px;
      display: block;
    }
  }
}

.fa {
  margin-right: 4px;
}
.el-form-item__label {
  border-bottom: 1px solid #d1dbe5;
}

.inherit {
  font-size: inherit;
  font-weight: inherit;
  border: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/app/CardListItem.vue